import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'pakistan_does_employer_maintain_fair_price_shop'

export const dataPointDefinition = {
  retracedId: 'pakistan_does_employer_maintain_fair_price_shop',
  name: 'Pakistan: Does the employer maintain a fair price shop?',
  description:
    'This question is specific to Pakistan only. Please consult the Law Overlay for more information on applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'wb-wage-116',
      number: 'WB-WAGE-156',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-116', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36060,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
